export function canEmbedPdf() {
  try {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) return false;
    return Boolean(navigator.pdfViewerEnabled);
  } catch {
    return false;
  }
}
